import React from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'stores';
import { FeatureToggle } from 'stores/ToggleStore';
import { ActionIcon, CancelIcon } from 'components/Icon';
import { Toggle } from 'components/Form/Toggle';

import { FullyBoundedToggleCreator } from './FullyBoundedToggleCreator';

interface Props
{
  featureToggle: FeatureToggle,
  isToggleOn?: boolean
  currentScope: string,
}

export const ToggleList: React.FC<Props> = observer(({featureToggle, currentScope, isToggleOn}) =>
{
  const { uiStore, toggleStore } = useStore();
  const toggle = featureToggle.toggles?.find(x => x.path === currentScope);
  const currentToggleIsOn = toggle ? toggle.is_enabled || false : isToggleOn;
  const currentScopeNormalized =  currentScope === '/' ? '' : currentScope;
  const currentScopeParts = currentScopeNormalized.split('/');
  const currentScopeDisplayName = currentScope === '/' ? currentScope : currentScopeParts.slice(-1);
  const togglesInCurrentScope = featureToggle.toggles?.filter(x => x.path !== currentScope && x.path?.startsWith(currentScope));
  const uniqueNextLevelPaths = Array.from(new Set(togglesInCurrentScope?.map(x => x.path?.split('/').slice(currentScopeParts.length)[0])))

  const createToggleHandler = async () =>
  {
    await toggleStore.createAsync(featureToggle.id || 0, currentScope, !currentToggleIsOn);
  }
  const deleteToggleHandler = async () =>
  {
    if (window.confirm(uiStore.labels.pages.toggles.deleteToggleConfirmation.apply({featureName: featureToggle.name, scope: toggle?.path})))
    {
      await toggleStore.deleteAsync(toggle?.id || 0);
    }
  }

  return (
    <div className="toggle-list">
      <div className="toggle-item">
        {
          toggle
          ? <Toggle value={currentToggleIsOn || false} onClick={createToggleHandler} disabled={toggleStore.toggle.isLoading} />
          : <FullyBoundedToggleCreator isToggleOn={currentToggleIsOn} featureId={featureToggle.id || 0} scope={currentScope} />
        }
        <div className="toggle-item-scope">{currentScopeDisplayName} { toggle ? <ActionIcon action={deleteToggleHandler} disabled={toggleStore.toggle.isLoading}><CancelIcon /></ActionIcon> : null }</div>
      </div>
      {
        uniqueNextLevelPaths.length > 0
        ? uniqueNextLevelPaths.map(x => <ToggleList key={`${currentScopeNormalized}/${x}`} featureToggle={featureToggle} currentScope={`${currentScopeNormalized}/${x}`} isToggleOn={currentToggleIsOn} />)
        : null
      }
    </div>
  );
});